module.exports = __webpack_public_path__ + "media/images/map-icons/open-osm-0d11d45edc95ad5a5088766452f9a422.png";